module.exports.default = {
    "ORDER": "Comanda",
    "SCHEDULE.YOU_ARE_ALL_SET": "",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "El teu lliurament està programat per",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Hola #, si us plau, programa el teu lliurament",
    "SCHEDULE.SCHEDULE_NOW": "Reprograma",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Lliurament y Actualització d’Estats",
    "SCHEDULE.EMAIL_UPDATES": "Actualitzacions per correu electrònic",
    "SCHEDULE.SMS_UPDATES": "Actualitzacions per SMS",
    "SCHEDULE.DISABLE_UPDATES": "No vull rebre actualitzacions",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "M’agradaria rebre informació actualitzada sobre la meva comanda als canals següents:",
    "OOPS": "Disculpa!",
    "SOMETHING_WENT_WRONG": "Alguna cosa ha anat malament",
    "REFRESH": "Refresca",
    "PAGE_NOT_FOUND": "La pàgina no s’ha trobat",
    "COULD_NOT_FIND_PAGE": "No s’ha trobat la pàgina que busques.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "No es pot enviar un missatge buit",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Si us plau, envia el teu missatge al repartidor",
    "TRACKING.SEND": "Envia",
    "TRACKING.ARRIVING_AT": "Arriba a les",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "minuts",
    "TRACKING.MAP": "Mapa",
    "TRACKING.SATELLITE": "Satèl·lit",
    "TRACKING.TERRAIN": "Terreny",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Hola, he arribat!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": ",el teu repartidor, ha arribat a",
    "COMPLETED": "Completat",
    "RATING.SKIP": "Ara no",
    "RATING.WHAT_WENT_WELL": "Què va sortir bé?",
    "RATING.WHAT_WENT_WRONG": "Què va sortir malament?",
    "RATING.THANK_YOU": "Gràcies",
    "RATING.FOR_USING_OUR_SERVICE": "per fer servir aquest servei!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Com ha estat la teva experiència d’entrega?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Gràcies per fer servir aquest servei",
    "SCHEDULE.RATE_US": "Valora’ns",
    "TERM_OF_USE": "Condicions d’ús",
    "PRIVACY_POLICY": "Política de privacitat",
    "SHARING_MY_LOCATION": "S’està compartint la meva ubicació",
    "SHARING_LOADING": "S’està carregant",
    "REQUIRED_FIELD_MESSAGE": "El camp és obligatori",
    "CONTACT_NAME": "Nom del contacte",
    "PHONE_NUMBER": "Número de telèfon",
    "EMAIL_ADDRESS": "Adreça electrònica",
    "SEND": "Envia",
    "FORWARD.THIS_ORDER": "Envia aquesta comanda",
    "FORWARD.TO_CONTACT": "Envia per posar-te en contacte",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Segur que vols enviar aquesta comanda?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "t’ha enviat una comanda",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Segur que vols rebutjar aquesta comanda?",
    "ACCEPT": "Accepta",
    "REJECT": "Rebutja",
    "PICKUP.SET_PICKUP_TIME": "",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "minuts",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "Omet",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "El teu lliurament està programat per",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Per poder valorar, selecciona primer les estrelles",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "",
    "TRACKING.MESSAGE_DRIVER": "",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "",
    "RATING.ORDER_DELIVERED_GREEN": "",
    "CX_ORDER_STATUS.CONFIRMED": "",
    "CX_ORDER_STATUS.RECEIVED": "",
    "CX_ORDER_STATUS.FINDING_DRIVER": "",
    "CX_ORDER_STATUS.DRIVER_FOUND": "",
    "CX_ORDER_STATUS.PICKING_UP": "",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "",
    "CX_ORDER_STATUS.ARRIVED": "",
    "TRACKING.DELIVERY_STATUS_TITLE": "",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "",
    "CONFIRM": "",
    "FLOW_OPTIONS.TITLE": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "",
    "RATING_STAR_ALT_TWO": "",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": "",
    "SCHEDULE.CANCEL_NOTE_INPUT": "",
    "DELIVERY_WAS_CANCELLED": "",
    "QUESTIONNAIRE.SKIP": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "",
    "QUESTIONNAIRE.BACK": "",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": ""
};
	